import React, { useCallback, useState } from "react";
import {
  Dialog,
  ListItem,
  Pane,
  Text,
  toaster,
  UnorderedList,
} from "evergreen-ui";
import useControlHub from "../hooks/useControlHub";

const VendorsDeleteDialog = ({ onClose, onFailure, onSuccess, vendors }) => {
  const { api } = useControlHub();
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    Promise.all(
      vendors.map(({ id: vendorID }) =>
        api.replaceVendor({ vendorID, vendorData: { user_active: false } })
      )
    )
      .then((results) => {
        const unsuccessful = results.filter((result) => !result.success);
        if (unsuccessful.length) {
          unsuccessful
            .filter((data) => data.message)
            .forEach((data) => toaster.danger(data.message));
          throw new Error("Some vendor deleting was unsuccessful");
        }
        toaster.success("Vendors deleted successfully");
        onSuccess();
      })
      .catch((error) => {
        setLoading(false);
        toaster.danger(
          error?.message || "Error: Vendor(s) failed to be deleted"
        );
        onFailure();
      });
  }, [api, onFailure, onSuccess, vendors]);

  return (
    <Dialog
      isConfirmLoading={loading}
      isShown={true}
      onCloseComplete={handleClose}
      onConfirm={handleConfirm}
      title="Delete Vendors"
    >
      <Pane display="flex" flexDirection="column" margin={16}>
        <Text>{`Delete ${vendors.length} vendors?`}</Text>
        <UnorderedList marginTop={16}>
          {vendors.map((vendor) => (
            <ListItem key={`vendorListIem - ${vendor["id"]}`}>
              {vendor["name"]}
            </ListItem>
          ))}
        </UnorderedList>
      </Pane>
    </Dialog>
  );
};

export default VendorsDeleteDialog;
